module.exports = __webpack_public_path__ + "assets/img/filter.bb8cdceb.svg";